import dayjs, { Dayjs } from 'dayjs'
import duration from 'dayjs/plugin/duration'
import customParseFormat from 'dayjs/plugin/customParseFormat'

dayjs.extend(duration)
dayjs.extend(customParseFormat)

const TIMESTAMP_PARAM = 't'

export const getTimePickerValueFromSeconds = (seconds: number) => {
  const date = dayjs().startOf('day').second(seconds)
  return dayjs(date, 'HH:mm:ss')
}

export const removeTimestampFromYoutubeLink = (link: string) => {
  let url

  try {
    url = new URL(link)
  } catch (e) {
    return link
  }

  url.searchParams.delete(TIMESTAMP_PARAM)

  return url.toString()
}

export const getTimestampFromYoutubeLink = (link: string) => {
  let url

  try {
    url = new URL(link)
  } catch (e) {
    return null
  }

  const timestampParam = url.searchParams.get(TIMESTAMP_PARAM)

  if (!timestampParam) {
    return null
  }

  const paramHMSFormat = timestampParam.match(/(?:(\d+)h)?(?:(\d+)m)?(?:(\d+)s)?/)

  const [matched, hours = 0, minutes = 0, seconds = 0] = paramHMSFormat ?? []

  let timestampInSeconds
  if (matched) {
    timestampInSeconds = dayjs
      .duration({ hours: Number(hours), minutes: Number(minutes), seconds: Number(seconds) })
      .asSeconds()
  } else {
    timestampInSeconds = Number(timestampParam)
  }

  return !isNaN(timestampInSeconds) ? timestampInSeconds : null
}

export const formatYoutubeLink = (link: string | null, timestamp?: Dayjs | null) => {
  if (!link) {
    return
  }

  let linkUrl: URL

  try {
    linkUrl = new URL(link)
  } catch (e) {
    return {
      link: null,
      timestamp: null,
    }
  }
  let inSeconds: number | null

  if (timestamp) {
    const hours = timestamp?.hour()
    const minutes = timestamp?.minute()
    const seconds = timestamp?.second()

    const duration = dayjs.duration({ hours, minutes, seconds })
    inSeconds = duration.asSeconds()
  } else {
    inSeconds = getTimestampFromYoutubeLink(link)
  }

  linkUrl.searchParams.delete(TIMESTAMP_PARAM)
  const formattedLink = linkUrl.toString()

  return {
    link: formattedLink,
    timestamp: inSeconds ?? 0,
  }
}
